/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { PlcHttpConfig, PlcHttpConfigToken } from './services.models';

import { EmptyRequest } from '../models/empty.request';
import { BagelPhase } from '../models/bagel-phase.entity';
import { UpdateBagelPhaseRequest } from '../models/update-bagel-phase.request';
import { Bagel } from '../models/bagel.entity';
import { UpdateBagelV3Request } from '../models/update-bagel-v3.request';
import { FixBagelV3Request } from '../models/fix-bagel-v3.request';

export type BagelPhaseCreatePathVariables = { gameId: string };
export type BagelPhaseUpdatePathVariables = { gameId: string; id: string };
export type BagelPhaseUpdateV3PathVariables = { gameId: string; id: string };

@Injectable()
export class BagelPhaseService {
	constructor(
		@Inject(PlcHttpConfigToken) private config: PlcHttpConfig,
		private http: HttpClient,
	) {}

	/**
	 * @deprecated This method will be deprecated in upcoming versions by GameController.update
	 */
	public create(
		path: BagelPhaseCreatePathVariables,
		body: EmptyRequest,
	): Observable<BagelPhase> {
		return this.http.post<BagelPhase>(
			`${this.config.apiUrl}/api/v2/private/games/${path.gameId}/phases/bagels`,
			body,
		);
	}

	/**
	 * @deprecated use updateV3 instead
	 */
	public update(
		path: BagelPhaseUpdatePathVariables,
		body: UpdateBagelPhaseRequest,
	): Observable<Bagel> {
		return this.http.patch<Bagel>(
			`${this.config.apiUrl}/api/v2/private/games/${path.gameId}/phases/bagels/${path.id}`,
			body,
		);
	}

	public updateV3(
		path: BagelPhaseUpdateV3PathVariables,
		body: UpdateBagelV3Request | FixBagelV3Request,
	): Observable<Bagel> {
		return this.http.patch<Bagel>(
			`${this.config.apiUrl}/api/v3/private/games/${path.gameId}/phases/bagels/${path.id}`,
			body,
		);
	}
}
